/*
 * General tools for arrays.
 */

export default {

    /**
     * Finds an item in an array by the provided property.
     *
     * @param {Array} arr
     * @param {string} property
     * @param {any} value
     * @returns {any} The item
     */
    findByProperty(arr, property, value) {
        for (let i = 0; i < arr.length; i += 1) {
            if (arr[i][property] === value)
                return arr[i]

        }

        return undefined
    },

    /**
     * Finds an item in an array by the provided property.
     *
     * @param {Array} arr
     * @param {string} property
     * @param {any} value
     * @returns {any} The item
     */
    findLastByProperty(arr, property, value) {
        for (let i = arr.length - 1; i > -1; i -= 1) {
            if (arr[i][property] === value)
                return arr[i]

        }

        return undefined
    },

    /**
     * Finds the index of an item in an array by the provided property.
     *
     * @param {Array} arr
     * @param {string} property
     * @param {any} value
     * @returns {number} The index
     */
    indexByProperty(arr, property, value) {
        for (let i = 0; i < arr.length; i += 1) {
            if (arr[i][property] === value)
                return i

        }

        return -1
    },

    /**
     * Finds the index of an item in an array by the provided property.
     *
     * @param {Array} arr
     * @param {string} property
     * @param {any} value
     * @returns {number} The index
     */
    lastIndexByProperty(arr, property, value) {
        for (let i = arr.length - 1; i > -1; i -= 1) {
            if (arr[i][property] === value)
                return i

        }

        return -1
    },

    /**
     * Moves an item from one place in an array to another.
     *
     * @param {Array} arr
     * @param {number} oldIndex
     * @param {number} newIndex
     * @returns {Array} The array
     */
    move(arr, oldIndex, newIndex) {
        if (newIndex >= arr.length) {
            let k = newIndex - arr.length + 1
            while (k--)
                arr.push(undefined)

        }

        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])

        return arr
    },

    /**
     * Swaps 2 items in an array.
     *
     * @param {Array} arr
     * @param {number} firstIndex
     * @param {number} secondIndex
     * @returns {Array} The array
     */
    swap(arr, firstIndex, secondIndex) {
        const temp = arr[firstIndex]
        arr[firstIndex] = arr[secondIndex]
        arr[secondIndex] = temp
        return arr
    },

    /**
     * Sort an array by the given property.
     * @param {string} prop The property name to sort by.
     * @returns {Function}
     */
    sortByProperty(prop) {
        return (a, b) => {
            a = a[prop]
            b = b[prop]

            return a == b ? 0 : a < b ? -1 : 1
        }
    },
}
